var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath87(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 172.695,
    height: 123.256,
    viewBox: "0 0 172.695 123.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M2863.888,640.561a21.155,21.155,0,0,1-8.276,15.866,17.887,17.887,0,0,1-2.448,1.665l-17.09,9.892-1.078.636-16.5,9.549-17.335,9.99-8.815,5.093-8.569,4.946a21.057,21.057,0,0,1-10.97,2.889,21.607,21.607,0,0,1-19.489-12.928,20.732,20.732,0,0,1-1.812-8.618V657.553h-42.211a18.069,18.069,0,1,1,0-36.138H2751.5V599.378a22.3,22.3,0,0,1,1.714-8.569,21.468,21.468,0,0,1,30.557-10.039l8.569,4.946,26.15,15.083,34.67,20.027c.1.049.2.147.294.2a21.289,21.289,0,0,1,10.43,19.539",
    transform: "translate(-2691.223 -577.833)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath87);
export default __webpack_public_path__ + "static/media/Path 87.249ab9c24152b41ac6b4d86630fe8621.svg";
export { ForwardRef as ReactComponent };